import { AccountInvestmentTypeView, CompanyView } from '@/types/entity-types';
import { LegalEntityCountry, WealthKernelInvestmentAccountStatus } from '@seapoint/server/enums';
import { TreasuryStep } from '../treasury-flow';

type GetTreasuryFlowStepProps = {
  company: CompanyView;
  investmentAccount?: AccountInvestmentTypeView;
  isEuCompanyWithTreasury: boolean | undefined;
};

export const getTreasuryFlowStep = ({
  company,
  investmentAccount,
  isEuCompanyWithTreasury,
}: GetTreasuryFlowStepProps): TreasuryStep => {
  if (company.legalEntity.country !== LegalEntityCountry.GB) {
    if (!isEuCompanyWithTreasury) {
      return 'EMPTY_STATE_EU_WAIT_LIST';
    }
  }

  if (company.acceptedKiids.length === 0) {
    return 'EMPTY_STATE_NO_KIID';
  }

  if (!investmentAccount) {
    return 'EMPTY_STATE_NO_ACCOUNT';
  }

  if (investmentAccount.status === WealthKernelInvestmentAccountStatus.PENDING) {
    return 'EMPTY_STATE_PENDING';
  }

  return 'APPROVED';
};
